import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';

import AccountCircle from '@material-ui/icons/AccountCircle';


const MenuDesktop = ({ menuId, handleProfileMenuOpen, numNotifications }) => {
    return (
        <>
            <IconButton color="primary">
                <Badge badgeContent={numNotifications} color="primary" width="25" height="25">
                <span className="material-icons" width="50" >notifications_active
                </span>
                </Badge>
            </IconButton>
            <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
            >
                <AccountCircle color='primary'/>
            </IconButton>
        </>
    )
};


export default MenuDesktop;



